import { useEffect } from "react";

const BASE = "https://vashi-accountancy.preview.emergentagent.com";

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export const SEO = ({ title, description, path = "/" }) => {
  useEffect(() => {
    document.title = title;
    upsert('meta[name="description"]', { name: "description", content: description });
    upsert('meta[property="og:title"]', { property: "og:title", content: title });
    upsert('meta[property="og:description"]', { property: "og:description", content: description });
    upsert('meta[property="og:url"]', { property: "og:url", content: `${BASE}${path}` });
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${BASE}${path}`);
  }, [title, description, path]);
  return null;
};
